export default __webpack_public_path__ + "static/media/icon-service.9a5b1c82.svg";